import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { useDispatch } from 'react-redux';
import { hooks, signaling } from '@lifesize/clients.sdk';
import { openInCallModal } from 'actions/InCallModal';
import Switch from 'components/Controls/Switch';
import modals from 'constants/Modals';
import classes from './CallDetails.module.scss';

interface Props {
  intl: { formatMessage: Function };
  isWaitingRoomFeatureEnabled: boolean;
  isVmr: boolean;
}

const messages = defineMessages({
  waitingRoom: { id: 'components.inCall.waitingRoom', defaultMessage: 'Waiting Room' },
  lockMeeting: { id: 'components.inCall.meetingLock.title', defaultMessage: 'Lock Meeting' }
});

const MeetingLock = (props: Props) => {
  const dispatch = useDispatch();
  const isRequestingLockUnlockMeeting = hooks.useRequestingLockUnlockMeeting();
  const isMeetingLocked = hooks.useIsWaitingRoomEnabled();
  const waitingRoomUsers = hooks.useWaitingRoomUsers() || [];
  const showOption = (props.isVmr && props.isWaitingRoomFeatureEnabled) || !props.isWaitingRoomFeatureEnabled;

  const handleChange = () => {
    if (props.isWaitingRoomFeatureEnabled && isMeetingLocked && waitingRoomUsers.length) {
      dispatch(openInCallModal(modals.waitingRoomWarningModal));
    } else if (isMeetingLocked) {
      signaling.disableWaitingRoom();
    } else {
      signaling.enableWaitingRoom();
    }
  };

  return showOption ? (
    <div className={classes.meetingLockContainer} data-testid={isMeetingLocked ? 'btnUnlockMeeting' : 'btnLockMeeting'}>
      <Switch
        className={classes.fillWidth}
        classNameLabel={classes.label}
        disabled={isRequestingLockUnlockMeeting}
        input={{
          checked: isMeetingLocked,
          name: 'meetingLock',
          onChange: () => handleChange(),
          value: true
        }}
        label={
          props.isWaitingRoomFeatureEnabled
            ? props.intl.formatMessage(messages.waitingRoom)
            : props.intl.formatMessage(messages.lockMeeting)
        }
        labelLeft={true}
      />
    </div>
  ) : (
    <></>
  );
};

export default injectIntl(MeetingLock);
